import qs from 'querystring'

export default () => qs.decode(window.location.search.substr(1))
